// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Button, Group, Stack, Text as MantineText, Text as ModalTitleText, Title } from '@mantine/core';
import { closeModal, openModal } from '@mantine/modals';
import { NavigateFunction } from 'react-router-dom';
import { RoutingS } from '../../../Service/RoutingS';

const TEAM_ADDON_MISSING_MODAL_ID = 'team-addon-missing';
const TEAM_ADDON_QUANTITY_MODAL_ID = 'team-addon-quantity';

export const openTeamAddonMissingModal = (navigate: NavigateFunction) => {
  const openPlans = () => {
    closeModal(TEAM_ADDON_MISSING_MODAL_ID);
    navigate(RoutingS.ROUTES.PLANS);
  };

  openModal({
    modalId: TEAM_ADDON_MISSING_MODAL_ID,
    title: (
      <ModalTitleText size="lg" weight="bolder">
        Team Addon fehlt
      </ModalTitleText>
    ),
    children: (
      <Stack spacing="md">
        <MantineText>
          Für weitere Teammitglieder und die Verwaltung von Berechtigungen benötigst Du das Team Addon.
        </MantineText>
        <Group position="right">
          <Button variant="default" onClick={() => closeModal(TEAM_ADDON_MISSING_MODAL_ID)}>
            Abbrechen
          </Button>
          <Button onClick={openPlans}>Addon buchen</Button>
        </Group>
      </Stack>
    ),
  });
};

export const openTeamAddonQuantityModal = (
  navigate: NavigateFunction,
  quantity: number | undefined,
  teamMemberCount: number,
) => {
  const openPlans = () => {
    closeModal(TEAM_ADDON_QUANTITY_MODAL_ID);
    navigate(RoutingS.ROUTES.PLANS);
  };

  openModal({
    modalId: TEAM_ADDON_QUANTITY_MODAL_ID,
    title: <Title order={4}>Mitarbeiter-Anzahl erhöhen</Title>,
    children: (
      <Stack spacing="md">
        <MantineText>
          Dein Team Addon enthält aktuell {quantity ?? 0} Mitarbeiter. Du hast bereits {teamMemberCount} Teammitglieder
          angelegt. Erhöhe die Anzahl der Mitarbeiter im Addon, um weitere Teammitglieder hinzuzufügen.
        </MantineText>
        <Group position="right">
          <Button variant="default" onClick={() => closeModal(TEAM_ADDON_QUANTITY_MODAL_ID)}>
            Abbrechen
          </Button>
          <Button onClick={openPlans}>Addon anpassen</Button>
        </Group>
      </Stack>
    ),
  });
};
